export default function sidebarComponent(Alpine) {
  Alpine.data("sidebarComponent", () => ({
    collapsed: false,
    pageString: "",
    groupCode: "",
    pendingGroup: "",
    // iconSprite: "",
    init() {
      const sidebar = document.getElementById("sidebar");
      this.collapsed = sidebar ? sidebar.hasAttribute("data-sidebar") : false;

      this.pageString = this.$el.dataset.pageString;
      // this.iconSprite = this.$el.dataset.staticUrl + "/svgs/dashboard-icons.svg";

      const state = document.getElementById("dashboard-state");

      if (state) {
        this.pageString = state.dataset.pageString;
        this.groupCode = state.dataset.groupCode;
      }

      document.body.addEventListener("htmx:oobAfterSwap", (event) => {
        if (event.target.id !== "dashboard-state") {
          return;
        }

        this.updatePageString(event.target.dataset.pageString);
        this.updateGroupCode(event.target.dataset.groupCode);
      });

      // 2. CRITICAL FIX: Handles back/forward button clicks
      // Re-reads the historical values directly from the restored DOM node
      document.addEventListener("htmx:historyRestore", () => {
        const restoredState = document.getElementById("dashboard-state");
        if (restoredState) {
          this.updatePageString(restoredState.dataset.pageString);
          this.updateGroupCode(restoredState.dataset.groupCode);
        }
      });
    },

    updatePageString(key) {
      this.pageString = key;
    },

    updateGroupCode(key) {
      this.groupCode = key;
    },
    togglePendingGroup(key) {
      if (this.pendingGroup === key) {
        this.pendingGroup = "";
      } else {
        this.pendingGroup = key;
      }
    },

    // iconHref(name) {
    //   return `${this.iconSprite}#${name}`;
    // },

    toggleSidebar() {
      this.collapsed = !this.collapsed;
      const sidebar = document.getElementById("sidebar");
      if (sidebar) sidebar.toggleAttribute("data-sidebar", this.collapsed);
      document.cookie = `sidebar_collapsed=${this.collapsed ? "true" : "false"};path=/;max-age=31536000;samesite=lax`;
    },
  }));
}
